export default __webpack_public_path__ + "static/media/bayer.d5a41ec5.png";